import { render, staticRenderFns } from "./stampPictureView.vue?vue&type=template&id=2c63a556&"
import script from "./stampPictureView.vue?vue&type=script&lang=js&"
export * from "./stampPictureView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c63a556')) {
      api.createRecord('2c63a556', component.options)
    } else {
      api.reload('2c63a556', component.options)
    }
    module.hot.accept("./stampPictureView.vue?vue&type=template&id=2c63a556&", function () {
      api.rerender('2c63a556', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Cargo/Job/stampPictureView.vue"
export default component.exports